import { config } from 'enviroment.js'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Modal, message, Form, Input, Button, Popconfirm } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'
import { getCookie } from 'common/utils/auth'

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${getCookie('token')}`,
}

function VideoItemModal(props) {
  const {
    visible,
    setVisible,
    activeItem,
    setActiveItem,
    setVideos,
    experienceInfo,
  } = props
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    if (activeItem) {
      // Parse data if it's a string, otherwise use directly
      let data = activeItem.data
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (e) {
          data = {}
        }
      }

      form.setFieldsValue({
        videoId: activeItem?.id,
        url: data?.src || '',
        displayName: data?.name || '',
      })
    }
  }, [form, activeItem, experienceInfo])

  const onCancel = () => {
    setVisible(false)
    setActiveItem(null)
    form.resetFields()
  }

  const onSubmit = (values) => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true)
        let formData = new FormData()
        formData.append('xExperienceId', activeItem.xExperienceId)
        formData.append('mediaType', 'video')
        formData.append('url', values.url)
        formData.append('displayName', values.displayName)
        formData.append('experienceName', experienceInfo?.name || '')
        formData.append('store', experienceInfo.store)

        // Add insert position info if adding before/after
        if (activeItem.actionType === 'add' && activeItem.insertPosition) {
          formData.append('insertPosition', activeItem.insertPosition)
          formData.append(
            'referenceOrderNumber',
            activeItem.referenceOrderNumber
          )
        }

        const videoId = values.videoId
        let url = config.raUrl + `/admin/media/${videoId}/`
        let requestType = 'put'
        if (activeItem.actionType === 'add') {
          url = config.raUrl + '/admin/media/create/'
          requestType = 'post'
        }

        axios[requestType](url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: headers.Authorization,
          },
        })
          .then((res) => {
            setLoading(false)
            setVisible(false)
            setActiveItem(null)
            form.resetFields()
            setVideos(res.data)
            message.success('Video updated!')
          })
          .catch((err) => {
            setLoading(false)
            console.log('error caught: ', err)
            message.error('Something went wrong!')
          })
      })
      .catch((errorInfo) => {
        console.log(errorInfo)
      })
  }

  const submitDelete = () => {
    axios
      .delete(config.raUrl + `/admin/media/${activeItem.id}/`, {
        headers,
        data: {
          mediaType: 'video',
          xExperienceId: activeItem.xExperienceId,
        },
      })
      .then((res) => {
        setVisible(false)
        setActiveItem(null)
        form.resetFields()
        setVideos(res.data)
        message.success('Video deleted!')
      })
      .catch((err) => {
        console.log('error caught: ', err)
        message.error('Something went wrong!')
      })
  }

  return (
    <Modal
      title={activeItem?.actionType === 'add' ? 'Add Video' : 'Edit Video'}
      centered
      visible={visible}
      onCancel={onCancel}
      width={500}
      destroyOnClose={true}
      footer={
        activeItem?.actionType === 'add'
          ? [
              <Button key="2" onClick={onCancel}>
                Cancel
              </Button>,
              <Button
                key="3"
                type="primary"
                onClick={onSubmit}
                loading={loading}
              >
                Save
              </Button>,
            ]
          : [
              <Popconfirm
                key="1"
                placement="top"
                title="Are you sure?"
                onConfirm={submitDelete}
                okText="Delete"
                cancelText="Cancel"
              >
                <Button danger icon={<DeleteOutlined />} />
              </Popconfirm>,
              <Button key="2" onClick={onCancel}>
                Cancel
              </Button>,
              <Button
                key="3"
                type="primary"
                onClick={onSubmit}
                loading={loading}
              >
                Save
              </Button>,
            ]
      }
    >
      <Form name="videoItem" layout={'vertical'} autoComplete="off" form={form}>
        <Form.Item name="videoId" noStyle>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item
          label="URL"
          name="url"
          className="inputFormItem"
          rules={[
            {
              required: true,
              message: 'Please input a URL!',
            },
          ]}
        >
          <Input placeholder="Enter video URL" />
        </Form.Item>
        <Form.Item
          label="Display Name"
          name="displayName"
          className="inputFormItem"
          rules={[
            {
              required: true,
              message: 'Please input a display name!',
            },
          ]}
        >
          <Input placeholder="Enter display name" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default VideoItemModal
